module.exports = __webpack_public_path__ + "static-portal/img/loading1.8efba9c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading1.gif
// module id = Qx7P
// module chunks = 4